// Telemetry
import { PrivacyConcernMetadataProvider } from "@microsoft/1ds-privacy-guard-js";
/**
 * Provides specific overrides for the MetadataProvider in Privacy Guard Plugin.
 * The overrides help in identifying violating events uniquely based on session ID and sequence.
 */ export class PlannerPrivacyConcernMetadataProvider extends PrivacyConcernMetadataProvider {
    /**
     * Gets the event locator name for the telemetry item.
     * @param telemetryItem The telemetry item to extract the event locator name from.
     * @returns The event locator name.
     */ GetEventLocatorName(telemetryItem) {
        return "SessionIdWithEventSequence";
    }
    /**
     * Gets the event locator value for the telemetry item.
     * Combines session ID and sequence number to create a unique identifier for the event.
     * @param telemetryItem The telemetry item to extract the event locator value from.
     * @returns The event locator value.
     */ GetEventLocatorValue(telemetryItem) {
        const sessionId = telemetryItem.data?.["Session.Id"] ?? "";
        const sequence = telemetryItem.ext?.sdk?.seq ?? "";
        return `${sessionId}_${sequence}`;
    }
}
